<script lang="ts">
	import { tooltip } from "../../actions/tooltip";
	export let instructions: string = "";
	export let placement: TooltipPlacement = "right";
	export let size: number = 15;
	export let compact: boolean = false;
</script>

<div
	class="p-0.5 ml-0.5 cursor-help {$$props.class ?? ''}"
	use:tooltip="{{
		placement: placement,
		html: true,
		content: instructions,
		compact: compact
	}}">
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 256 256"
		width="{size}"
		style="margin-bottom: -1px">
		<rect width="256" height="256" fill="none"></rect><circle
			cx="128"
			cy="128"
			r="96"
			fill="none"
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="20"></circle
		><path
			d="M120,120a8,8,0,0,1,8,8v40a8,8,0,0,0,8,8"
			fill="none"
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="20"></path>
		<circle cx="124" cy="84" r="12" fill="currentColor"></circle>
	</svg>
</div>
